import { NavLink } from 'react-router-dom'
import { LayoutDashboard, ClipboardList, Ticket, Users, Bell } from 'lucide-react'
import { ROUTES } from '@/constants'
import { useAuthStore } from '@/store/authStore'

const BottomNav = () => {
  const { user } = useAuthStore()
  const isAdmin = user?.role === 'admin'

  const navItems = [
    { path: ROUTES.DASHBOARD,     icon: LayoutDashboard, label: 'Home',      grad: 'linear-gradient(135deg,#2563eb,#06b6d4)', glow: 'rgba(37,99,235,0.5)'   },
    { path: ROUTES.TASKS,         icon: ClipboardList,   label: 'Dockets',   grad: 'linear-gradient(135deg,#8b5cf6,#6366f1)', glow: 'rgba(139,92,246,0.5)'  },
    { path: ROUTES.TICKETS,       icon: Ticket,          label: 'Tickets',   grad: 'linear-gradient(135deg,#ef4444,#f97316)', glow: 'rgba(239,68,68,0.5)'   },
    { path: ROUTES.NOTIFICATIONS, icon: Bell,            label: 'Alerts',    grad: 'linear-gradient(135deg,#f59e0b,#f97316)', glow: 'rgba(245,158,11,0.5)'  },
    { path: ROUTES.ENGINEERS,     icon: Users,           label: isAdmin ? 'Team' : 'Team', grad: 'linear-gradient(135deg,#10b981,#059669)', glow: 'rgba(16,185,129,0.5)' },
  ]

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40"
      style={{
        background: 'linear-gradient(180deg,rgba(3,10,24,0.97) 0%,rgba(5,15,32,0.99) 100%)',
        backdropFilter: 'blur(24px) saturate(180%)',
        WebkitBackdropFilter: 'blur(24px) saturate(180%)',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '0 -4px 28px rgba(0,0,0,0.35)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="flex justify-around items-center h-[60px] px-2 pb-[env(safe-area-inset-bottom)]">
        {navItems.map(item => (
          <NavLink key={item.path} to={item.path} end={item.path === ROUTES.DASHBOARD}>
            {({ isActive }) => (
              <div className="flex flex-col items-center justify-center gap-0.5 py-1 px-3 select-none active:scale-95 transition-transform duration-100">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-2xl transition-all duration-200"
                  style={isActive ? { background: item.grad, boxShadow: `0 4px 16px ${item.glow}`, transform: 'translateY(-1px)' } : {}}
                >
                  <item.icon
                    size={19}
                    strokeWidth={isActive ? 2.5 : 1.8}
                    className={isActive ? 'text-white' : 'text-gray-500'}
                  />
                </div>
                <span className={`text-[9px] font-bold tracking-wide transition-colors ${isActive ? 'text-white' : 'text-gray-600'}`}>
                  {item.label}
                </span>
              </div>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

export default BottomNav
